/**
 * Authentication DTOs — request bodies + whoami identity contract.
 */

export interface SignInRequest {
  email: string;
  password: string;
}

export interface GoogleSignInRequest {
  idToken: string;
}

export type SignUpRole = 'mentor' | 'student';

export interface SignUpRequest {
  emailOrPhone: string;
  password: string;
  role?: SignUpRole;
}

export interface ForgotPasswordRequest {
  email: string;
}

/** GET /v1/auth/whoami — authentication identity (not user profile). */
export interface WhoAmIResponse {
  id: number;
  email: string | null;
  companyId: number;
  roles: string[];
}

export function resolveAppRoleFromRoles(
  roles: string[] | undefined,
): SignUpRole {
  const normalized = (roles ?? []).map(r => String(r).toLowerCase());
  return normalized.includes('mentor') ? 'mentor' : 'student';
}
